import React, { useEffect, useRef, useState } from 'react'
import VisualScreenHeader from './VisualScreenHeader'
import ParticleBackground from './proto/components/ParticleBackground'
import Dashboard from './proto/Dashboard'
import './Page.less'

/** 设计画板 1920×1080。宽、高分别铺满视口，不滚动 */
const DESIGN_WIDTH = 1920
const DESIGN_HEIGHT = 1080
/** 顶栏：margin-top 45 + height 44，弹出框从这条线下面开始 */
const MENU_DESIGN_HEIGHT = 89
const MODAL_OVERLAY_SELECTOR = [
  '.ds-modal-overlay',
  '.ol-modal-overlay',
  '.sa-modal-overlay',
  '.alert-detail-overlay',
  '.rss-overlay',
  '.wa-overlay',
  '.ma-modal-overlay'
].join(',')

const VisualScreenPage = () => {
  const viewportRef = useRef(null)
  const [storeId, setStoreId] = useState('86')
  const [bgVideoReady, setBgVideoReady] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    const el = viewportRef.current
    if (!el) return undefined

    const updateScale = () => {
      const w = el.clientWidth
      const h = el.clientHeight
      if (!w || !h) return
      const scaleY = h / DESIGN_HEIGHT
      el.style.setProperty('--vs-scale-x', String(w / DESIGN_WIDTH))
      el.style.setProperty('--vs-scale-y', String(scaleY))
      document.documentElement.style.setProperty('--vs-menu-h', `${MENU_DESIGN_HEIGHT * scaleY}px`)
    }

    updateScale()
    const ro = new ResizeObserver(updateScale)
    ro.observe(el)
    return () => {
      ro.disconnect()
      document.documentElement.style.removeProperty('--vs-menu-h')
    }
  }, [])

  useEffect(() => {
    document.documentElement.classList.add('visual-screen-page-lock')
    return () => document.documentElement.classList.remove('visual-screen-page-lock')
  }, [])

  useEffect(() => {
    const sync = () => {
      setModalOpen(Boolean(document.body.querySelector(MODAL_OVERLAY_SELECTOR)))
    }
    sync()
    const mo = new MutationObserver(sync)
    mo.observe(document.body, { childList: true })
    return () => mo.disconnect()
  }, [])

  return (
    <div className="visual-screen-viewport" ref={viewportRef}>
      <ParticleBackground />
      <div className="scanlines" />
      <div className="hud-ring hud-ring-1" />
      <div className="hud-ring hud-ring-2" />
      <div className="hud-ring hud-ring-3" />
      <div className="visual-screen-scale-slot">
        <div className="visual-screen-board">
        <div className="vs-top-bg">
          <div className="vs-top-bg__img vs-top-bg__img--a" />
          <div className="vs-top-bg__img vs-top-bg__img--b" />
        </div>
        <VisualScreenHeader storeId={storeId} onStoreIdChange={setStoreId} />
        <div className={`vs-bg-media${bgVideoReady ? ' video-ready' : ''}`}>
          <img className="vs-bg-image" src="/images/bg.png" alt="" />
          <video
            className="vs-bg-video"
            autoPlay
            loop
            muted
            playsInline
            controls={false}
            controlsList="nodownload nofullscreen noremoteplayback"
            disablePictureInPicture
            disableRemotePlayback
            hidden={modalOpen}
            onCanPlay={() => setBgVideoReady(true)}
            onPlaying={() => setBgVideoReady(true)}
          >
            <source src="/images/bg.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="vs-main">
          <Dashboard storeId={storeId} />
        </div>
        </div>
      </div>
    </div>
  )
}

export default VisualScreenPage
